import Cookies from "js-cookie";
import { useMemo, useState } from "react";
import * as config from "../../../config/config";
import { getCompanyLogoImage } from "../../../helpers/data_management";
import { sendTrackingEvent } from "../../../helpers/tracking_management";
import {
  CompanyDetailsContainer,
  CompanyImageBanner,
  CompanyIndustry,
  CompanyLogo,
  CompanyName,
  ImageContainer,
  JobCount,
  JobIconStyled,
  LinkWrapper,
  Wrapper,
} from "./styles";

export default function CompanyCard(props) {
  const { company } = props;

  const [imageError, setImageError] = useState(false);

  const companyLogo = useMemo(() => {
    if (imageError) {
      return (
        config.assetDomain +
        "/images/backgrounds/hiredly-jobs-malaysia-wobb-background-v1.png"
      );
    }

    return getCompanyLogoImage(company);
  }, [company, imageError]);

  const companyImageBanner = "https:" + company?.coverImageThumb;

  const noImage = !company?.logo || imageError;

  function handleCardClick() {
    sendTrackingEvent({
      event: "CE_click-company-company-list",
      "company-id": company.id,
    });

    Cookies.set("click-source", "companies_page");
  }

  return (
    <LinkWrapper href={`/companies/${company?.slug}`} target="_blank">
      <Wrapper onClick={handleCardClick}>
        <ImageContainer>
          <CompanyImageBanner
            src={companyImageBanner}
            alt={company?.name}
            loading={"lazy"}
          />
          <CompanyLogo
            src={companyLogo}
            alt={company?.name}
            loading={"lazy"}
            $placeholder={noImage}
            onError={() => setImageError(true)}
          />
        </ImageContainer>

        <CompanyDetailsContainer>
          <CompanyName>{company.name}</CompanyName>
          <CompanyIndustry>{company.industry}</CompanyIndustry>
          {company.jobCount > 0 && (
            <JobCount>
              <JobIconStyled />
              {company.jobCount} jobs
            </JobCount>
          )}
        </CompanyDetailsContainer>
      </Wrapper>
    </LinkWrapper>
  );
}
